<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon"
    viewBox="0 0 40 40"
  >
    <path
      d="M21.6169 22.905L21.4665 22.9435V24.8004H18.5332V21.667C18.5332 21.278 18.6877 20.905 18.9628 20.6299C19.2378 20.3549 19.6109 20.2004 19.9999 20.2004C21.9487 20.2004 23.5332 18.6158 23.5332 16.667C23.5332 14.7182 21.9487 13.1337 19.9999 13.1337C18.1182 13.1337 16.5761 14.611 16.4721 16.467H13.5363C13.5871 14.8245 14.2617 13.2599 15.4272 12.0944C16.64 10.8817 18.2848 10.2004 19.9999 10.2004C21.7149 10.2004 23.3598 10.8817 24.5725 12.0944C25.7851 13.3071 26.4664 14.9517 26.4665 16.6667C26.464 18.097 25.9863 19.4859 25.1084 20.6151C24.2306 21.7443 23.0024 22.5498 21.6169 22.905Z"
    />
    <path
      d="M21.4665 29.8004H18.5332V26.867H21.4665V29.8004Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.5332 20.0004C3.5332 10.9058 10.9053 3.53369 19.9999 3.53369C29.0944 3.53369 36.4665 10.9058 36.4665 20.0004C36.4665 29.0949 29.0944 36.467 19.9999 36.467C10.9053 36.467 3.5332 29.0949 3.5332 20.0004ZM33.5332 20.0004C33.5332 12.5382 27.462 6.46702 19.9999 6.46702C12.5377 6.46702 6.46654 12.5382 6.46654 20.0004C6.46654 27.4625 12.5377 33.5337 19.9999 33.5337C27.462 33.5337 33.5332 27.4625 33.5332 20.0004Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconHelp',
};
</script>

<style scoped>
.icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  fill: inherit;
  flex-shrink: 0;
}
</style>
